/**
 * File group operations for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class FileGroupManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async listFileGroups(
    where?: Record<string, any>,
    page = 1,
    size = 1000,
  ): Promise<Record<string, any>> {
    const params: Record<string, any> = { page, size };
    if (where) params.options = JSON.stringify({ where });
    return this.session.get('/api/cdp_file_group/page', { params });
  }

  async listFiles(
    where?: Record<string, any>,
    page = 1,
    size = 1000,
  ): Promise<Record<string, any>> {
    const params: Record<string, any> = { page, size };
    if (where) params.options = JSON.stringify({ where });
    return this.session.get('/api/cdp_file/page', { params });
  }

  async uploadIfc(formData: FormData, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/cdp_file_group/extend/uploadBim', {
      data: formData,
      params,
      headers: {},
    });
  }

  async uploadDwg(formData: FormData, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/cdp_file_group/extend/uploadCad', {
      data: formData,
      params,
      headers: {},
    });
  }

  async uploadOriginModel(
    formData: FormData,
    params?: Record<string, any>,
  ): Promise<Record<string, any>> {
    return this.session.post('/api/model/upload', { data: formData, params, headers: {} });
  }

  async convertOriginModel(
    formData: FormData,
    params?: Record<string, any>,
  ): Promise<Record<string, any>> {
    return this.session.post('/api/model/convert', { data: formData, params, headers: {} });
  }
}
